/** Copy used when an invited player confirms they intend to decline. */
export function getDeclineInviteWarning() {
  return {
    title: 'Decline this game?',
    message:
      'You will give up your reserved seat in this game. Are you sure you want to decline the invitation?',
  }
}
